import React, { Component } from "react";
import { withLocalize } from "react-localize-redux";
import "./style.scss";

class PopupFilter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            color1 : '#F29D49',
            color2 : '#EEEEEE'
        }
    }

    handleChange = (e, value) => {
    }

    changeColor = (e, i) => {
        if (i) {
            this.setState({
                color1 : e.target.value
            });
        } else {
            this.setState({
                color2 : e.target.value
            })
        }
    }

    componentDidMount = () => {
        this.commonHideComponent('popup_player', 'popup_player_inner');
        
    }

    commonHideComponent = (p, c) => {
        const wrapWorkspace = document.getElementById(p);
        const workspace = document.getElementById(c);
        const self = this;
        wrapWorkspace.addEventListener('click', function (event) {
            const isClickInside = workspace.contains(event.target);
            if (!isClickInside) {
                self.closePopup();
            }
        });
    }

    closePopup = () => {
        this.props.closePopup();
    }

    render() {
        return (
            <div className='popup' id="popup_player">
                <div className='popup_inner' id="popup_player_inner">
                    <h3 className="title-popup">グラフ設定 Chart Setting</h3>
                    <div className="line-1">
                        <div>
                            <p className="title-select">X軸</p>
                            <select className="form-control">
                                <option>シーズン</option>
                                <option>シーズン</option>
                                <option>シーズン</option>
                                <option>シーズン</option>
                            </select>
                        </div>
                        <div>
                            <p className="title-select">Y軸</p>
                            <select className="form-control">
                                <option>シーズン</option>
                                <option>シーズン</option>
                                <option>シーズン</option>
                                <option>シーズン</option>
                            </select>
                        </div>
                        <div>
                            <p className="title-select">目盛</p>
                            <select className="form-control">
                                <option>試合</option>
                                <option>試合</option>
                                <option>試合</option>
                                <option>試合</option>
                            </select>
                        </div>
                    </div>
                    <div className="line-2">
                        <p className="title-select">対象</p>
                        <select className="form-control">
                            <option>試合</option>
                            <option>試合</option>
                            <option>試合</option>
                            <option>試合</option>
                        </select>
                    </div>
                    <div className="form-input-color">
                        <input type="text" className="input-form" name="name"  placeholder="菅野 智之" onChange={this.handleChange} />
                        <input type='color' value={this.state.color1} onChange={(e) => this.changeColor(e,1)}/>
                    </div>
                    <div className="form-input-color">
                        <input type="text" className="input-form" placeholder="Placeholder" />
                        <input type='color' value={this.state.color2} onChange={(e) => this.changeColor(e,0)} />
                    </div>  
                    
                    
                    <div className="button">
                        <p onClick={() => this.closePopup()}>キャンセル</p>
                        <p>更新</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default withLocalize(PopupFilter);